"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twMerge = void 0;
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
exports.twMerge = (0, utilities_1.createTwMerge)("koa");
